const IconBlock = (props) => {
  const handleClick = () => {
    if (props.link) {
      window.open(props.link, '_blank');
    }
  };

  return (
    <div className="icon-block">
      <button className="icon-btn" style={{ cursor: props.link ? "pointer" : "" }} onClick={handleClick}>
        {props.icon}
        <div className="label-container">
          <div className={props.link ? "text link" : "text"}>{props.label}</div>
        </div>
      </button>
    </div>
  );
};

export default IconBlock;
